import {
    areaCodeSchema,
    ElectionDataResponse,
} from '@west-australian-newspapers/election-api-types'

export type LowercaseElectionAreaCode =
    | 'federal'
    | 'wa'
    | 'nsw'
    | 'vic'
    | 'qld'
    | 'sa'
    | 'tas'
    | 'nt'
    | 'act'

/** The logo will fallback to mobile if desktop is not provided. */
export type ElectionLogo = {
    /** An image uri. */
    mobile: string
    /** An image uri. */
    desktop?: string
    /** A human readable description for screen-readers. */
    alt?: string
}

export type ElectionDefinition =
    | UnloadedElectionDefinition
    | LoadedElectionDefinition

export type UnloadedElectionDefinition = {
    loaded: false
    electionId: string
    logo: ElectionLogo
    meta: {
        /** 2400x1260px image URIs. */
        updatesSocialImage?: string
        electoratesSocialImage?: string
        partyTotalsSocialImage?: string
    }
}

/** Contains all the data relevant to an election. */
export type LoadedElectionDefinition = {
    loaded: true
    electionData: ElectionDataResponse
    electionId: string
    logo: ElectionLogo
    meta: {
        /** 2400x1260px image URIs. */
        updatesSocialImage?: string
        electoratesSocialImage?: string
        partyTotalsSocialImage?: string
    }
}

/** Decipher the wan election id into a consumable value. */
export const getElectionDataFromWanId = (
    wanElectionId: string,
): { areaCode: LowercaseElectionAreaCode; year: number } => {
    const splitId = wanElectionId.split('-')
    const [areaCode, _, year] = splitId

    if (!areaCode || !year) {
        throw new Error(`Invalid election id provided: ${wanElectionId}`)
    }

    if (areaCode === 'federal') {
        return {
            areaCode: 'federal',
            year: Number(year),
        }
    } else {
        const state = areaCode.toLowerCase()

        if (!areaCodeSchema.safeParse(areaCode.toUpperCase()).success) {
            throw new Error(`Invalid state provided: ${state}`)
        }

        return {
            areaCode: state as LowercaseElectionAreaCode,
            year: Number(year),
        }
    }
}
